<div class="layout-topbar">
    @defer{
        <a routerLink="{{loginServices.getDefaultRole()?.routerLink}}">
            <p-image alt="app logo" [src]="'assets/demo/images/logos/dot_logo.png'" width="50"></p-image>
        </a>

        <button #menubutton class="topbar-menubutton p-link" type="button" (click)="onMenuButtonClick()">
            <span></span>
        </button>

        <ul class="topbar-menu">
            <li *ngFor="let item of tabs; let i = index">
                <a [routerLink]="item.routerLink" routerLinkActive="active-route"
                   [routerLinkActiveOptions]="item.routerLinkActiveOptions||{paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored'}"
                   [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling"
                   [preserveFragment]="item.preserveFragment!" [skipLocationChange]="item.skipLocationChange!"
                   [replaceUrl]="item.replaceUrl!" [state]="item.state" [queryParams]="item.queryParams">
                    <span>{{ item.label }}</span>
                </a>
                <i class="pi pi-times" (click)="removeTab($event, item, i)"></i>
            </li>
        </ul>
        <div class="topbar-profile">
            <div class="flex align-items-center">
                <p-button
                        *ngIf="loginServices.hasRoles(['cliente_ventanilla']) && appComponent.showCart()"
                        (onClick)="completarPagos()"
                        label="Ir a pagos"
                        icon="pi pi-arrow-right"
                        styleClass="p-button-rounded w-full border-none px-3 py-2" [style]="{'background-color':'#3B82F6'}"/>
                <p-button iconPos="top"
                          *ngIf="loginServices.hasRoles(['cliente_ventanilla']) && appComponent.showCart()"
                          styleClass="p-button-rounded p-button-text" (onClick)="opDetails.toggle($event)">
                    <i class="pi pi-shopping-cart" pBadge style="font-size: 25px"
                       [value]="tramite.tramitesCarrito().length.toString()"
                       pTooltip="Tramites pendientes de pago"
                       severity="info"></i>
                </p-button>
            </div>
            <p-overlayPanel #opDetails [style]="{width: '300px'}">
                <ng-template pTemplate>
                    <p *ngIf="this.tramite.tramitesCarrito().length==0" [style]="{textAlign:'center'}">
                        <b>No hay tramites agregados</b>
                    </p>
                    <div *ngIf="this.tramite.tramitesCarrito().length!=0">
                        <div class="flex flex-column align-items-center mb-2">
                            <div>
                                <b>Tramites agregados</b>
                            </div>
                        </div>
                        <p-scroller [items]="this.tramite.tramitesCarrito()" [itemSize]="50" scrollHeight="500px"
                                    [style]="{'height': '500px'}">
                            <ng-template pTemplate="item" let-servicioCargado let-options="options">
                                <div class="flex align-items-center p-3 w-full flex-wrap">
                                    <div class="flex-1">
                                        <h5 class="mb-2 text-xs w-10">{{ servicioCargado.nombreTramite }}</h5>
                                        <span
                                            class="hidden md:inline-flex vertical-align-middle mr-2">{{ servicioCargado.nombreCategoria }}</span>
                                    </div>

                                </div>
                            </ng-template>
                        </p-scroller>
                        <div>
                            <div class="w-12rem hidden md:block"></div>
                            <ul class="list-none  flex-auto">
                                <li class="flex justify-content-star">
                                    <p-button class="mr-3" (onClick)="this.completarPagos();opDetails.toggle($event)"
                                              label="Proceder a completar"
                                              styleClass="p-button-outlined"></p-button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
            </p-overlayPanel>
        </div>
        <div *ngIf="!loginServices.isValid" class="topbar-profile">
            <div class="topbar-profile-button p-link" type="button" enterFromClass="hidden">
                <i class="pi pi-user" style="color:var(--red-400); font-size: 25px;"></i> &nbsp;
                <a href="auth/login" style="color: var(--red-400); font-size: 25px;">Iniciar sesión</a>
            </div>
        </div>
        <div *ngIf="loginServices.isValid" class="topbar-profile">
            <button class="topbar-profile-button p-link" type="button" pStyleClass="@next" enterFromClass="hidden"
                    enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                <img alt="avatar" [src]="imagenPerfil" style="border-radius:30%;">
                <span class="profile-details">
                    <span class="profile-name">{{ loginServices.session()?.perfil?.nombreCompleto }}</span>
                </span>
                <i class="pi pi-angle-down"></i>
            </button>
            <ul class="list-none p-3 m-0 border-round shadow-2 hidden absolute surface-overlay origin-top w-full sm:w-12rem mt-2 right-0 top-auto">
                <li>
                    <a pRipple [routerLink]="['/users/perfil']"
                       class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                        <i class="pi pi-user mr-3"></i>
                        <span routerLinkActive="router-link-active">Perfil</span>
                    </a>
                    <a pRipple
                       (click)="cerrarSesion()"
                       class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                        <i class="pi pi-power-off mr-3"></i>
                        <span routerLinkActive="router-link-active">Cerrar Sesión</span>
                    </a>
                </li>
            </ul>
        </div>
       } @loading () {
        <p-progressSpinner ariaLabel="loading"/>
    }
</div>
